import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold text-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-warm-900 cursor-pointer';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-400 text-warm-900 shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]',
    secondary: 'bg-transparent border-2 border-amber-500/50 text-amber-500 hover:bg-amber-500/10 hover:border-amber-500'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      // Fire Meta Pixel event before redirecting
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'InitiateCheckout', {
          content_name: '3AM otra vez Kit',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        ${baseStyles} 
        ${variants[variant]} 
        ${fullWidth ? 'w-full py-4' : 'px-8 py-3'} 
        ${className}
      `} {...props} data-id="element-207">
      {children}
    </motion.button>;
}